import { Translation } from "../../../hooks/useTranslations";
import { LatLng, Path } from "../../../types";

export type BorderConfigurationNode = {
  id: string;
  location: LatLng;
};

export type CornerClassificationValue = "internal" | "external";

export type CornerClassification = {
  value: CornerClassificationValue;
  label: string;
};

export const getCornerClassifications = (i18n: Translation): CornerClassification[] => [
  { value: "internal", label: i18n.common.internal },
  { value: "external", label: i18n.common.external },
];

export type BorderConfigurationSegment = {
  id?: string;
  startNodeId?: string | null;
  endNodeId?: string | null;
  sequenceOrder?: number | null;
  length?: number | null;
  orientation?: "parallel" | "perpendicular" | null;
  cornerClassification?: "internal" | "external" | null;
};

export type BorderGeometryResponse = {
  nodes: BorderConfigurationNode[];
  segments: BorderConfigurationSegment[];
  perimeter: number;
  totalCornerCount: number;
};

export type InsertBorderSegmentRequestBody = {
  path: Path;
};

export type UpdateBorderNodeLocationRequestBody = LatLng;
